import { render, staticRenderFns } from "./PresentationList.vue?vue&type=template&id=a7990a3c&scoped=true"
import script from "./PresentationList.vue?vue&type=script&lang=js"
export * from "./PresentationList.vue?vue&type=script&lang=js"
import style0 from "./PresentationList.vue?vue&type=style&index=0&id=a7990a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7990a3c",
  null
  
)

export default component.exports